import { render, staticRenderFns } from "./ZoneDetailBtn.vue?vue&type=template&id=254eb9ee"
import script from "./ZoneDetailBtn.vue?vue&type=script&lang=js"
export * from "./ZoneDetailBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports